import React, { Component } from "react";
import {
  InputSearch,
  NormalSelect,
  NormalTable,
  NormalButtonBackend,
} from "component/common";
import { withTranslation } from "react-i18next";
import { Myequipments } from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

export class EquipmentClass extends Component {
  state = {
    EquimentDetails: [
      {
        label: "Code",
        sortKey: "equipmentCode",
        enabled: true,
        id: "equipmentCode",
        singleClickFunc: () => this.handleSort("equipmentCode"),
      },
      {
        label: "Name",
        sortKey: "equipmentName",
        enabled: true,
        id: "equipmentName",
        singleClickFunc: () => this.handleSort("equipmentName"),
      },
      {
        label: "Description",
        sortKey: "equipmentDescription",
        enabled: true,
        id: "equipmentDescription",
        singleClickFunc: () => this.handleSort("equipmentDescription"),
      },
      {
        label: "Active",
        sortKey: "equipmentIsactive",
        enabled: true,
        id: "equipmentIsactive",
        singleClickFunc: () => this.handleSort("equipmentIsactive"),
      },
    ],
    option: [
      { label: 10, value: 10 },
      { label: 25, value: 25 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
    ],
    count: 10,
    is_loading: false,
    isoption: false,
    offset: 0,
    data: [],
    perPage: 10,
    List: [],
    search: "",
    filterdata: [],
    seachdata: [],
    pageMeta: {},
    staffList: [],
    currentPage: 1,
    activeButton: false,
    inactiveButton: false,
    isActive: false,
    isInactive: false,
    isAll: false,
    orderBy: "desc",
  };

  componentDidMount = () => {
    this.Listofequiments({});
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  /* List Sorting */
  handleSort = (sortkey) => {
    let { List, orderBy } = this.state;
    this.setState({
      orderBy: this.state.orderBy == "asc" ? "desc" : "asc",
    });
    console.log("che");
    if (orderBy === "asc") {
      List.sort((a, b) =>
        a[sortkey] > b[sortkey] ? 1 : b[sortkey] > a[sortkey] ? -1 : 0
      );
    } else {
      List.sort((a, b) =>
        a[sortkey] < b[sortkey] ? 1 : b[sortkey] < a[sortkey] ? -1 : 0
      );
    }
    this.setState({
      List,
    });
  };

  /* List of Equipments Function */
  Listofequiments = async () => {
    this.setState({
      is_loading: true,
      activeButton: false,
      inactiveButton: false,
    });
    await this.props.Myequipments().then((res) => {
      let {
        staffList,
        pageCount,
        List,
        pageMeta,
        count,
        perPage,
        currentPage,
      } = this.state;
      staffList = res;
      List = staffList.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
      pageCount = Math.ceil(staffList.length / this.state.perPage);
      this.setState({
        staffList,
        is_loading: false,
        pageCount,
        List,
        isActive: false,
        isInactive: false,
        isAll: true,
        pageMeta: { ...pageMeta, total_pages: pageCount, per_page: count },
      });
    });
  };

  /* List of Equipments Active List */
  Activeitem = async () => {
    this.setState({
      is_loading: true,
      activeButton: true,
      inactiveButton: false,
    });
    await this.props.Myequipments().then((res) => {
      let { pageCount, List, currentPage, perPage, pageMeta } = this.state;
      let Listone = [];
      for (let key of res) {
        if (key.equipmentIsactive === true) {
          Listone.push({
            equipmentName: key.equipmentName,
            equipmentDescription: key.equipmentDescription,
            equipmentCode: key.equipmentCode,
            equipmentIsactive: key.equipmentIsactive,
          });
        }
      }
      this.setState({ Listone });
      List = Listone.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
      pageCount = Math.ceil(Listone.length / this.state.perPage);
      this.setState({
        pageCount,
        List,
        is_loading: false,
        isActive: true,
        isInactive: false,
        isAll: false,
        pageMeta: { ...pageMeta, total_pages: pageCount },
      });
    });
  };

  /* List of Equipments InActive List */
  Inactiveitem = async () => {
    this.setState({
      is_loading: true,
      activeButton: false,
      inactiveButton: true,
    });
    await this.props.Myequipments().then((res) => {
      let { pageCount, List, currentPage, perPage, pageMeta } = this.state;
      let Listone = [];
      for (let key of res) {
        if (key.equipmentIsactive === false) {
          Listone.push({
            equipmentName: key.equipmentName,
            equipmentDescription: key.equipmentDescription,
            equipmentCode: key.equipmentCode,
            equipmentIsactive: key.equipmentIsactive,
          });
        }
      }
      List = Listone.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
      pageCount = Math.ceil(Listone.length / this.state.perPage);
      this.setState({
        pageCount,
        List,
        is_loading: false,
        isActive: false,
        isInactive: true,
        isAll: false,
        pageMeta: { ...pageMeta, total_pages: pageCount },
      });
    });
  };

  /* Pagination Limit Set Function */
  temp = ({ target: { value, name } }) => {
    let { count, perPage, pageMeta } = this.state;
    if (name == "count") {
      count = value;
      perPage = +value;
      this.setState({
        count,
        perPage,
        pageMeta: { ...pageMeta, per_page: +perPage },
      });
      this.Listofequiments();
    }
  };

  /* page click function */
  handlePageClick = (e) => {
    let { isActive, isInactive, isAll } = this.state;
    const selectedPage = e.page;
    const offset = selectedPage * this.state.perPage;
    this.setState(
      {
        currentPage: selectedPage,
        pageMeta: { ...this.state.pageMeta, current_page: selectedPage },
        offset: offset,
      },
      () => {
        if (isActive) {
          this.Activeitem();
        } else if (isInactive) {
          this.Inactiveitem();
        } else if (isAll) {
          this.Listofequiments();
        }else{
          this.handleFilterChange();
        }
      }
    );
  };

  handleFilterChange = () => {
    let {
      staffList,
      pageCount,
      filterdata,
      search,
      seachdata,
      perPage,
      currentPage,
      pageMeta,
      count,
    } = this.state;
    filterdata = staffList.filter((item) => {
      return Object.values(item)
        .join("")
        .toLowerCase()
        .includes(search.toLowerCase());
    });
    this.setState({ filterdata });
    seachdata = filterdata.slice(
      (currentPage - 1) * perPage,
      (currentPage - 1) * perPage + perPage
    );
    pageCount = Math.ceil(filterdata.length / this.state.perPage);
    this.setState({
      seachdata,
      pageCount,
      pageMeta: { ...pageMeta, total_pages: pageCount, perPage: count },
    });
  };

  /* Description Filter Function */
  filterByName = ({ target: { value, name } }) => {
    let { 
      staffList, 
      filterdata, 
      search, 
      seachdata, 
      pageCount,
      activeButton,
      inactiveButton,
      pageMeta,
      perPage,
      count, 
      currentPage
    } = this.state;
    if (name === "search") {
      search = value;
      this.setState({ search });
    }
    if (search.length === 0) {
      this.Listofequiments();
    }
    if (search !== "") {
      filterdata = staffList.filter((item) => {
        const isActive = item.equipmentIsactive ? "Yes" : "No";
        const lowerCaseSearch = search.toLowerCase();
        const lowerCaseName = item.equipmentName ? item.equipmentName.toLowerCase(): "";
        const lowerCaseDesc = item.equipmentDescription ? item.equipmentDescription.toLowerCase(): "";
        const lowerCaseCode = item.equipmentCode ? item.equipmentCode.toLowerCase(): "";
        const lowerCaseActive = isActive ? isActive.toLowerCase(): "";

        if (activeButton && item.equipmentIsactive === false) {
          return false;
        }

        if (inactiveButton && item.equipmentIsactive === true) {
          return false;
        }

        return (
          lowerCaseName.includes(lowerCaseSearch) ||
          lowerCaseDesc.includes(lowerCaseSearch) ||
          lowerCaseCode.includes(lowerCaseSearch) ||
          lowerCaseActive.includes(lowerCaseSearch)
        );
      });
    } else {
      filterdata = staffList;
    }

    this.setState({ filterdata });
    if (filterdata.length < 10) {
      seachdata = filterdata;
    } else {
      seachdata = filterdata.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
    }
    pageCount = Math.ceil(filterdata.length / this.state.perPage);
    this.setState({ 
      seachdata, 
      pageCount,
      isActive:false,
      isInactive:false,
      isAll:false,
      pageMeta:{...pageMeta, total_pages:pageCount,perPage:count},
    });
  };

  render() {
    let {
      EquimentDetails,
      is_loading,
      option,
      count,
      search,
      filterdata,
      pageMeta,
      List,
      isActive,
      isInactive,
      isAll
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid department-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="align-items-center">
                <div className="col-12">
                  <h4 className="label-head text-center text-md-left text-lg-left mt-3 mb-0">
                    {t("Appointment Config")}
                  </h4>
                </div>
                <div className="col-12">
                  <p className="label-title text-center text-md-left text-lg-left mt-2">
                    {t("Equipment")}
                  </p>
                </div>
                <div className="mt-3 col-12 d-md-flex justify-content-md-between m-0 p-0">
                  <div className="d-md-flex col-12 col-md-4">
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"All"}
                        isActive={isAll}
                        onClick={this.Listofequiments}
                      />
                    </div>
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Active"}
                        isActive={isActive}
                        onClick={this.Activeitem}
                      />
                    </div>
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Inactive"}
                        isActive={isInactive}
                        onClick={this.Inactiveitem}
                      />
                    </div>
                  </div>
                  <div className="p-1 col-12 col-md-4">
                    <InputSearch
                      type="search"
                      placeholder={t("Search")}
                      onChange={this.filterByName}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-center justify-content-md-start col-12 mt-3">
                  <p className="mt-2 mr-1">{t("Show")}</p>
                  <div className="p-1">
                    <NormalSelect
                      options={option}
                      value={count}
                      onChange={this.temp}
                      name="count"
                    />
                  </div>
                  <p className="mt-2 ml-1">{t("Entries")}</p>
                </div>
              </div>
              {search.length > 0 ? (
                <div className="tab-table-content">
                  <div className="py-4">
                    <div className="table-container">
                      <NormalTable
                        headerDetails={EquimentDetails}
                        pageMeta={pageMeta}
                        queryHandler={(event) => this.handlePageClick(event)}
                      >
                        {is_loading ? (
                          <tr>
                            <td colSpan="7">
                              <div class="d-flex mt-5 align-items-center justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : filterdata.length > 0 ? (
                          filterdata.map(
                            (
                              {
                                equipmentCode,
                                equipmentDescription,
                                equipmentIsactive,
                                equipmentName,
                              },
                              index
                            ) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <div
                                      className="text-left text-primary"
                                      onClick={() =>
                                        this.props.history.push(
                                          `/admin/backend/Equimentid/${equipmentCode}`
                                        )
                                      }
                                    >
                                      {equipmentCode}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {equipmentName}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {equipmentDescription}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {equipmentIsactive == true ? "Yes" : "No"}
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : null}
                      </NormalTable>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="tab-table-content">
                  <div className="py-4">
                    <div className="table-container">
                      <NormalTable
                        headerDetails={EquimentDetails}
                        pageMeta={pageMeta}
                        queryHandler={(event) => this.handlePageClick(event)}
                      >
                        {is_loading ? (
                          <tr>
                            <td colSpan="7">
                              <div class="d-flex mt-5 align-items-center justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : List.length > 0 ? (
                          List.map(
                            (
                              {
                                equipmentCode,
                                equipmentDescription,
                                equipmentIsactive,
                                equipmentName,
                              },
                              index
                            ) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <div
                                      className="text-left text-primary"
                                      onClick={() =>
                                        this.props.history.push(
                                          `/admin/backend/Equimentid/${equipmentCode}`
                                        )
                                      }
                                    >
                                      {equipmentCode}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {equipmentName}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {equipmentDescription}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {equipmentIsactive == true ? "Yes" : "No"}
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : null}
                      </NormalTable>
                    </div>
                  </div>
                </div>
              )}
              <div
                className="icon"
                onClick={() =>
                  this.props.history.push(`/admin/backend/appointment/equipemt`)
                }
              >
                +
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      Myequipments,
    },
    dispatch
  );
};

export const Equipment = withTranslation()(
  connect(null, mapDispatchToProps)(EquipmentClass)
);
